import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { parseMileage } from '../../../helpers/inspectionForm';
import s from '../Inspection.css';

// Mileage in km: a text field with a numeric keypad on phones, validated as a whole number >= 0.
export function MileageInput({ id, value, onChange, disabled, intl, errorKey }) {
  const { formatMessage } = intl;
  if (disabled) {
    const parsed = parseMileage(value);
    return <p className={s.readOnlyValue}>{parsed === null ? '-' : `${parsed.toLocaleString(intl.locale)} ${formatMessage(messages.inspKm)}`}</p>;
  }
  const errorId = `${id}-error`;
  return (
    <div>
      <div className={s.mileageBox}>
        <input
          id={id}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          className={cx(s.input, errorKey && s.inputError)}
          value={value}
          aria-label={formatMessage(messages.inspMileageTitle)}
          aria-invalid={errorKey ? 'true' : undefined}
          aria-describedby={errorKey ? errorId : undefined}
          onChange={(event) => onChange(event.target.value)}
        />
        <span className={s.mileageUnit}>{formatMessage(messages.inspKm)}</span>
      </div>
      {errorKey && <p id={errorId} className={s.errorText} role="alert">{formatMessage(messages[errorKey])}</p>}
    </div>
  );
}

MileageInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  errorKey: PropTypes.string
};
MileageInput.defaultProps = { id: 'inspection-mileage', value: '', onChange: () => {}, disabled: false };

export default injectIntl(withStyles(s)(MileageInput));
